import { ApolloClient, InMemoryCache } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

const singleValueResultResponse = async (response: any) => {
  return { result: response.json() };
};

export const apolloClient = new ApolloClient({
  link: new RestLink({
    uri: process.env.REACT_APP_API_URL,
    endpoints: {
      endpointcanje: {
        uri: '' + process.env.REACT_APP_API_URL,
        responseTransformer: singleValueResultResponse,
      },
      endpointstatus: {
        uri: process.env.REACT_APP_STATUS_URL!,
      },
    },
  }),
  cache: new InMemoryCache(),
});
